import { useEffect, useState } from "react";
import api from "../../../../api";
import BaseHr from "../../../SharedComponents/components/Dividers/BaseHr";


const getDaysAgo = (createdAt) => {
  const createdTime = new Date(createdAt).getTime();; 
  const now = Date.now();
  const diffInMs = now - createdTime;
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24)); 
  return diffInDays;
};

const OldNotifications = () => {
    const [oldNotifications, setOldNotifications] = useState([]);
    const [oldNotificationsCount, setOldNotificationsCount] = useState(0);

    useEffect(() => {
        const fetchOldNotifications = async () => {
            try{
                const response = await api.get('/seller/notifications/old');
                setOldNotifications(response.data.data);
                setOldNotificationsCount(response.data.count);
                
            } catch(err){
                console.log("Greška pri učitavanju starih obaveštenja, ", err);
            }
        };
        fetchOldNotifications();
    }, [])
  return (
        <div>
            <div>
                <h5 style={styles.header}>Prethodna obaveštenja</h5>
            </div>
            <div>
                {oldNotifications.length > 0 ? (
                oldNotifications.map((notification) => (
                    <div key={notification.system_message_id} style={styles.notification}>
                        <div style={styles.titleRegion}>
                            <p style={styles.notificationTitle}>{notification.title}</p>
                            <p> Pre {getDaysAgo(notification.createdAt)} dana</p>
                        </div>
                    <p style={styles.notificationMessage}>{notification.message}</p>
                    <BaseHr />
                    </div>
                ))
                ) : (
                <p>Nema starih obaveštenja.</p>
                )}
                
            </div>
        </div>
    );
};

const styles = {
    header : {
        fontSize : "24px",
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight : "bold",
        marginTop : "39px",
    },
    titleRegion : {
        display : "flex",
        justifyContent : "space-between"
    },
    notificationTitle : {
        fontSize : "16px",
        fontWeight : "bold",
        color : 'rgba(0,0,0,0.87)'
    },
    notificationMessage : {
        color : 'rgba(0, 0, 0, 0.87)',
        marginBottom : "15px"
    },
    notification : {
        marginBottom : "15px"
    }
}

export default OldNotifications;
